import { render, staticRenderFns } from "./AdminMain.vue?vue&type=template&id=198dcb31"
import script from "./AdminMain.vue?vue&type=script&lang=js"
export * from "./AdminMain.vue?vue&type=script&lang=js"
import style0 from "./AdminMain.vue?vue&type=style&index=0&id=198dcb31&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports